import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

import { Box } from '@chatterbug/aaron'
import Action from 'src/ui/Action/Action'
import VocabularyWordList from 'src/ui/VocabularyWordList/VocabularyWordList'

const WrapupCardVocabularyGroup = ({ title, items, action, theme }) => {
  if (!items?.length) {
    return null
  }

  return (
    <Box position="relative">
      <Box variant="text.h5" mb="1x">
        {title}
      </Box>
      <VocabularyWordList items={items} />
      {action && (
        <Box
          position={{ tabletWide: 'absolute' }}
          top={{ tabletWide: 0 }}
          right={{ tabletWide: 0 }}
          mt={{ _: '3x', tabletWide: 0 }}
          mx={`-${theme.space['1x']}`}
        >
          <Action href={action.link}>{action.label}</Action>
        </Box>
      )}
    </Box>
  )
}

WrapupCardVocabularyGroup.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }),
}

export default withTheme(WrapupCardVocabularyGroup)
